export default __webpack_public_path__ + "static/media/gpsspinner.f298977e.gif";